import { HostConfig } from 'common/types'

const hostConfig: HostConfig = {
  ...require(`./${process.env.NODE_ENV}`).default,
}

export default { ...hostConfig }
